import {useContext} from 'react'
import {Container} from './components/Container'
import {Header} from './components/Header'
import {RedHeader} from './components/RedHeader'
import {CustomLanding36252Context} from '../../../../reducer'
import {t} from '../../../../i18n'
import {Button} from '@material-ui/core'
import {Subheader} from './components/Subheader'
import {Bold} from './components/Bold'
import {CustomLanding36252ActionType} from '../../../../types'

export const HeroLeft = (): React.ReactElement => {
  const [state, dispatch] = useContext(CustomLanding36252Context)

  const handleDismiss = () => {
    dispatch?.({
      type: CustomLanding36252ActionType.Dismiss,
    })
  }

  return (
    <Container>
      <Header>
        {t[state.language].heroBlackHeader}
        <RedHeader>{t[state.language].heroRedHeader}</RedHeader>
      </Header>
      <Subheader>
        {t[state.language].heroSubheader}
        <Bold> {t[state.language].heroSubheaderBold}</Bold>
      </Subheader>
      <Button
        variant="contained"
        color="primary"
        style={{fontSize: '16px'}}
        onClick={handleDismiss}
      >
        {t[state.language].claimMyBonus}
      </Button>
    </Container>
  )
}
